import * as React from 'react'
import * as Enum from '@owl-nest/legacy-enum'

export const Step = Enum.create({
  BEFORE: 'before',
  DURING: 'during',
  AFTER: 'after',
})
export type Step = Enum.ValueOf<typeof Step>

export type UseTransition = {
  step: Step
  unmounted: boolean
  onTransitionEnd: (event: React.TransitionEvent) => void
}

export function useTransition(visible: boolean): UseTransition {
  const [shouldRender, setRender] = React.useState(false)
  const isHookMountedRef = React.useRef(false)

  React.useEffect(() => {
    isHookMountedRef.current = true

    return () => {
      isHookMountedRef.current = false
    }
  }, [])

  React.useEffect(() => {
    if (visible) {
      // on utilise un setTimeout pour garantir que le setRender déclenchera un rerender différent du rerender à l'origine du useEffect (éviter le batch des renders)
      // ceci permet de garantir qu' on aura un render avec un step 'before' distinct du render immédiat suivant en step 'during'
      setTimeout(() => {
        if (isHookMountedRef.current) {
          setRender(true)
        }
      }, 0)
    }
  }, [visible])

  const onTransitionEnd = (event: React.TransitionEvent): void => {
    // since transitionend bubble, check if the event came from our element. If
    // it came from a different element, we do nothing
    if (event.target !== event.currentTarget) {
      return
    }
    if (!visible) {
      setRender(false)
    }
  }

  let step: Step
  if (visible && !shouldRender) {
    step = Step.BEFORE
  } else if (!visible && shouldRender) {
    step = Step.AFTER
  } else {
    step = Step.DURING
  }

  const unmounted = !visible && !shouldRender

  return { step, unmounted, onTransitionEnd }
}
